import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";
import "./PricingPlan.css";
import ReadMore from "../../CommonUI/ReadMoreBtn/ReadMore";
import LandingHeader from "./../LandingHeader/LandingHeader";
function PricingPlan(props) {

  let pricing = window.location.pathname;
  pricing = pricing.replace('/', '');
  let navigate = useNavigate();

  const PlanAClick = (evt) => {
    const plan = evt;
    let path = `../Pricing`;
    if (props.product != 'Products') {
      props.Plan_details(plan);

      window.scrollTo({
        top: 1200,
        behavior: 'smooth',
      });
    }
    else
      navigate(path, { state: { plan: evt } });
  };
  return (
    <>
    <LandingHeader/>
      <div class="marginprice_grid d-flex landingpag_price">
        <div class="marginprice_box marginprice_20box">
          <h3><i class="fa fa-rupee"></i><span>20</span>
            <span class="lading_plan"><small>Plan</small> A</span>
          </h3>
          <p>Per order +
            interest on ledger balance
            + Zero delivery
            Brokerage
          </p>
        </div>
        <div class="marginprice_box marginprice_10box">
          <h3><i class="fa fa-rupee"></i><span>10</span><span class="lading_plan"><small>Plan</small> B</span></h3>
          <p>Per order only (No hidden charges)
          </p>
        </div>
      </div>
      <p>* <a href="/TermsCondition">T&C</a> apply.</p>
    </>
  );
}
export default PricingPlan;
